import styled from "@emotion/styled"
import BeautyshotCardPush from "components/cards/beautyshot-card/BeautyshotCard"
import Image from "components/media/ImageCLD"
import getMediaQuery from "css/breakpoints"
import { useDictionary } from "contexts/Dictionary"
import { LabelFont } from "../watch-card/WatchCard"
import { useRef } from "react"

const Item = styled.div`
  cursor: pointer;
  grid-column: span 2;
  position: relative;
  overflow: hidden;
  height: 100%;
  display: grid;
  grid-template: "container";
  align-items: flex-end;
  justify-items: flex-end;

  ${getMediaQuery("m")} {
    grid-column: unset;
  }

  > div {
    grid-area: container;

    button {
      margin-inline-end: 3vw;
      margin-block-end: 3vw;

      ${getMediaQuery("xl")} {
        margin-inline-end: 2vw;
        margin-block-end: 2vw;
      }
    }
  }
`
const Figure = styled.figure`
  display: block;
  width: 100%;
  grid-area: container;
  pointer-events: none;

  img {
    display: block;
    width: 100%;

    // ${getMediaQuery("m")} {
    //   position: absolute;
    //   top: 0;
    //   left: 0;
    //   object-fit: cover;
    //   object-position: center;
    //   height: 100%;
    // }
  }
`
const Label = styled.span`
  ${LabelFont}
  position: absolute;
  bottom: 3vw;
  left: 3vw;

  ${getMediaQuery("m")} {
    [dir="rtl"] & {
      left: unset;
      right: 3vw;
    }
  }

  ${getMediaQuery("xl")} {
    bottom: 2vw;
    left: 2vw;

    [dir="rtl"] & {
      left: unset;
      right: 2vw;
    }
  }
`

export default function BeautyshotCard({ rmc, version, theme, new_model, onClick, discoverlabel, ...props }) {
  const dictionary = useDictionary()
  const ref = useRef(null)

  const image = {
    // alt: "",
    loading: "lazy",
    sizes: "(min-width: 80rem) 33vw, (min-width: 64.0625rem) 50vw, 100vw",
    sources: [
      {
        height: "680",
        public_id: `rolexcom/collection/watches-grid/beautyshot-cards/${rmc}/${rmc}_${version}`,
        width: "1072",
        policy: "",
      },
    ],
  }

  function handleClick(e = {}) {
    if (e.currentTarget && !e.target.contains(e.currentTarget)) return
    const btn = ref.current?.querySelector("button")
    if (btn && e.target.contains(btn)) {
      e.preventDefault()
      btn?.click()
    }
  }

  return (
    <Item ref={ref} className={theme ? theme : "dark-theme"} data-test={rmc} onClick={handleClick}>
      <Figure>
        <Image aria_label={discoverlabel} alt={rmc} {...image} />
      </Figure>
      {new_model && <Label>{dictionary.newModel()}</Label>}
      <BeautyshotCardPush rmc={rmc} discoverlabel={discoverlabel} version={version} image={image} onClick={onClick} />
    </Item>
  )
}
